module.exports = __webpack_public_path__ + "0e80c6e0.svg";